import { HYGRAPH_PAGE_LI_DASHBOARD_ID } from 'constants/hygraphShemeId';
import { conditionFragment } from 'constants/query/conditionQuery';
import {
  buttonFragment,
  colorsFragment,
  getImageQueryFragment,
  richTextFragment,
} from 'petdna-lib-uicomponents/hygraph';

const GET_LOGGED_IN_DASHBOARD_CARD_FRAGMENT = `... on Card {
  id
  name
  contentDate
  title {
    ${richTextFragment}
  }
  text {
    ${richTextFragment}
  }
  textPlacement
  button {
    ${buttonFragment}
  }
  backgroundImage {
    ${getImageQueryFragment({})}
  }
  textColor {
    ${colorsFragment}
  }
  backgroundColor {
    ${colorsFragment}
  }
  bottomImage {
    ${getImageQueryFragment({})}
  }
  bottomImagePlacement
  bottomImageBottomDistance
  paginationColor {
    ${colorsFragment}
  }
  conditions {
    ${conditionFragment}
  }
  entitlements
}`;

export const GET_LOGGED_IN_DASHBOARD_QUERY = `query PageLIDashboard($id: ID = "${HYGRAPH_PAGE_LI_DASHBOARD_ID}"){
  pageLiDashboard(where: {id: $id}) {
    name
    cards {
      ${GET_LOGGED_IN_DASHBOARD_CARD_FRAGMENT}
    }
  }
}
`;
